const mapLayers = {
  options: {
    layers: 'Layers',
    ev: 'EV',
    bookings: 'Bookings',
    heatMap: 'Heat Map',
  },
  legend: {
    powerType: {
      slow: 'Lento',
      fast: 'Rápido',
      turbo: 'Turbo',
    },

    availability: {
      available: 'Disponible',
      notAvailable: 'No disponible',
      selected: 'Seleccionado',
      broken: 'Quebrado',
      unknown: 'Desconocido',
    },


  },
};

export default mapLayers;